<template>
    <div id="auto-reply-list" class="page-content">
        <!-- Spinner On load -->
        <spinner v-if="replies.length == 0 && loading" class="spinner" />

         <!-- If no AutoReplies -->
         <p v-if="replies.length == 0 && !loading" class="empty-message">
            {{ $t('settings.auto_reply.empty') }}
        </p>

        <!-- Conversation items -->
        <transition-group name="flip-list" tag="div">
            <component :is="'AutoReplyItem'" v-for="reply in replies" :key="reply.id" :reply-data="reply" />
        </transition-group>

        <button v-mdl tag="button" class="create-auto-reply-button mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored" :style="{ background: $store.state.colors_accent }" @click="create">
            <i class="material-icons md-light">add</i>
        </button>
    </div>
</template>

<script>
import Hash from 'object-hash';
import { Api, SessionCache } from '@/utils';
import AutoReplyItem from './AutoReplyItem.vue';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'AutoReplies',

    components: {
        AutoReplyItem,
        Spinner
    },

    data () {
        return {
            title: "Auto Replies",
            loading: true,
            replies: SessionCache.getAutoReplies(),
        };
    },

    mounted () {
        this.$store.state.msgbus.$on('refresh-btn', this.refresh);

        this.fetchAutoReplies();

        // Construct colors object from saved global theme
        const colors = {
            'default': this.$store.state.theme_global_default,
            'dark': this.$store.state.theme_global_dark,
            'accent': this.$store.state.theme_global_accent,
        };

        // Commit them to current application colors
        this.$store.commit('colors', colors);
    },

    beforeDestroy () {
        this.$store.state.msgbus.$off('refresh-btn', this.refresh);
    },

    methods: {

        fetchAutoReplies () {
            Api.autoReplies.get()
                .then(response => this.processAutoReplies(response));
        },

        render (argsAutoReplies) {
            let autoReplies = [];
            let drivingAutoReply = null;
            let vacationAutoReply = null;
            let keywordAutoReplies = [];
            let contactAutoReplies = [];

            for(let i = 0; i < argsAutoReplies.length; i++) {
                const autoReply = argsAutoReplies[i];
                switch (autoReply.reply_type) {
                    case 'driving':
                        drivingAutoReply = autoReply;
                        break;
                    case 'vacation':
                        vacationAutoReply = autoReply;
                        break;
                    case 'keyword':
                        keywordAutoReplies.push(autoReply);
                        break;
                    case 'contact':
                        contactAutoReplies.push(autoReply);
                        break;
                }
            }
            if (drivingAutoReply) {
                autoReplies.push(drivingAutoReply);
            }
            if (vacationAutoReply) {
                autoReplies.push(vacationAutoReply);
            }
            // ASC sort by id
            keywordAutoReplies = keywordAutoReplies.sort((a, b) => a.id - b.id);
            contactAutoReplies = contactAutoReplies.sort((a, b) => a.id - b.id);
            autoReplies = autoReplies.concat(contactAutoReplies).concat(keywordAutoReplies);
            this.replies = autoReplies;
        },

        processAutoReplies (response) {
            this.render(response);
            this.loading = false;
            this.$store.commit("loading", false);
            this.$store.commit('title', this.title);
        },

        refresh () {
            if (this.loading) {
                return;
            }
            this.loading = true;
            SessionCache.invalidateAutoReplies();
            this.fetchAutoReplies();
        },
        create () {
            this.$dialog.confirm(
                this.$t('settings.auto_reply.prompt'), { okText: this.$t('settings.auto_reply.type_contact'), cancelText: this.$t('settings.auto_reply.type_keyword')})
                .then(() => {
                    this.$router.push({ name: 'create-auto-reply', query: { type: 'contact' } });
                })
                .catch(() => {
                    this.$router.push({ name: 'create-auto-reply', query: { type: 'keyword' } });
                });
        }
    },

    watch: {
        '$store.state.auto_replies': function () {
            if (this.loading) {
                return;
            }
            this.render(SessionCache.getAutoReplies());
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../../assets/scss/_vars.scss";

    #auto-reply-list {
        width: 100%;

        .spinner {
            margin-top: 100px;
        }
    }

    .flip-list-enter, .flip-list-leave-to	{
        opacity: 0;
    }

    .flip-list-leave-active {
        position: absolute;
    }

    .flip-list-move {
        transition: transform $anim-time;
    }

    .create-auto-reply-button {
        position: fixed;
        bottom: 0%;
        right: 0%;
        z-index: 3;
        margin: 24px;
    }
</style>
